// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_17fGHX","button":"_3bZ5mz","text":"_10jBxt"};